






















































































































































































































import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IOutbound from '@/store/models/IOutbound';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import moment from 'moment';
import IStock from '@/store/models/IStock';
import OutboundDeliveryNoteDetailCustomerStockSelector from '@/components/selectors/Outbounds/OutboundDeliveryNoteDetailCustomerStockSelector.vue';
import IOutboundDeliveryNoteProduct from '@/store/models/IOutboundDeliveryNoteProduct';
import Snackbar from '@/components/shared/Snackbar.vue';
import { sum } from 'lodash';
import IWarehouse from '@/store/models/IWarehouse';
@Component({
    components: {
        OutboundDeliveryNoteDetailCustomerStockSelector,
        Snackbar
    }
})
export default class OutboundDeliveryNotesDetailSelector extends Vue {
    searchOutboundDeliveryNotesDetail: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headersOutboundDeliveryNotesDetail: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Good Code', value: 'goodCode' },
        { text: 'Pallet type', value: 'palletName' },
        { text: 'Pallet id', value: 'idPallet' },
        { text: 'Location', value: 'location' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Good per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Cases loss', value: 'casesLoss' },
        { text: 'Weight', value: 'weight' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Reference dossier number', value: 'referenceInboundCode' },
        { text: 'Language', value: 'language' },
        { text: 'Actions', value: 'actions' }
    ];
    headersOutboundDeliveryNotesProducts: any = [
        { text: 'Good', align: 'start', value: 'goodName' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Weight per pallet (kg)', value: 'totalWeight' },
        { text: 'In delivery note', value: 'inDeliveryNote' }
    ];

    editedIndex : number = -1;
    editedItem : IOutboundDeliveryNotesDetail = {
        id: "",
        idOutboundDeliveryNote: "",
        idOutboundDetail: "",
        idGood: "",
        goodName: "",
        goodCode: "",
        idListPallet: "",
        palletName: "",
        idPallet: "",
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        weight: 0,
        bestBeforeDate: new Date(),
        casesLoss: 0,
        language: "",
        idPalletCustomer: "",
        location: ""
    }
    defaultItem : IOutboundDeliveryNotesDetail = {
        id: "",
        idOutboundDeliveryNote: "",
        idOutboundDetail: "",
        idGood: "",
        goodName: "",
        goodCode: "",
        idListPallet: "",
        palletName: "",
        idPallet: "",
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        weight: 0,
        bestBeforeDate: new Date(),
        casesLoss: 0,
        language: "",
        idPalletCustomer: "",
        location: ""
    }

    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesDetailList !: IOutboundDeliveryNotesDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    SelectedOutbound !: IOutbound;
    @Prop({ type: Array, required: true })
    CustomerStockDeliveryNoteDetail !: IStock[];
    @Prop()
    SelectedWarehouse !: IWarehouse;
    @Prop({ type: Array, required: true })
    OutboundDetails !: IOutboundDetail[];
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedOutbounds !: boolean;
    @Prop({ type: Boolean, default: false })
    IsShared !: boolean;
    @Prop({ type: Boolean, default: false })
    ScannerActive!: boolean;

    OutboundDeliveryNoteProductSelected : IOutboundDeliveryNoteProduct[] = [];
    selectedOutboundDeliveryNotesDetail : IOutboundDeliveryNotesDetail[] = [];
    selectedStockCustomerToDelivery : IStock[] | null = null;

    get formTitle() { return this.editedIndex === -1 ? 'New Delivery Notes Detail' : 'Edit Delivery Notes Detail'; }
    get totalPalletsSelected(): number {
        return this.selectedStockCustomerToDelivery ? this.selectedStockCustomerToDelivery.length : 0;
    }

    get totalCasesSelected(): number {
        if (!this.selectedStockCustomerToDelivery) return 0;
        return this.selectedStockCustomerToDelivery.reduce((sum, item) => sum + (item.totalCases || 0), 0);
    }

    get totalGoodsSelected(): number {
        if (!this.selectedStockCustomerToDelivery) return 0;
        return this.selectedStockCustomerToDelivery.reduce((sum, item) => sum + (item.totalGoods || 0), 0);
    }
   
    get MaxCases(): number {
        return this.OutboundDeliveryNoteProductSelected.length > 0
            ? this.OutboundDeliveryNoteProductSelected[0].totalCases
            : 0;
    }

    async mounted() {
    // 👉 Si el escáner está activo, cambiar cabecera de Language → Merken nummer
        if (this.ScannerActive) {
            const idx = this.headersOutboundDeliveryNotesDetail.findIndex(
                (h: { text: string; value: string }) => h.value === 'language'
            );
            if (idx !== -1) {
                this.headersOutboundDeliveryNotesDetail[idx].text = 'Merken nummer';
                this.headersOutboundDeliveryNotesDetail[idx].value = 'idPalletCustomer';
            }
        }
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }
   
    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    HasRightModifyCompletedOutbounds() {
        if (!this.Permissions[0].isWritable || (this.SelectedOutbound.statusName === 'Completed' && !this.CanModifyCompletedOutbounds)) return false;
        return true;
    }
    
    get CustomerStockToDelivery() {
        return Object.assign([], this.CustomerStockDeliveryNoteDetail);
    }

    get IsOverLimit(): boolean {
        if (!this.selectedStockCustomerToDelivery || this.selectedStockCustomerToDelivery.length === 0) {
            return false;
        }
        const totalSelected = this.selectedStockCustomerToDelivery.reduce((sum, item) => sum + (item.totalCases || 0), 0);
        return totalSelected > this.MaxCases;
    }

    getColor(item : IOutboundDetail) : string {
        if (item.inDeliveryNote === null) {
            item.inDeliveryNote = 0;
            return 'white';
        } else if (item.inDeliveryNote < item.totalCases) return 'orange';
        else if (item.inDeliveryNote === item.totalCases) return 'green';
        item.inDeliveryNote = 0;
        return 'white';
    }

    get OutboundDeliveryNotesProductList(): IOutboundDeliveryNoteProduct[] {
        let outboundDeliveryNoteProduct: IOutboundDeliveryNoteProduct[] = [];
        if (this.OutboundDetails.length > 0) {
            this.OutboundDetails.forEach(p => {
                if (p.idWarehouse === this.SelectedWarehouse.id) {
                    let product: IOutboundDeliveryNoteProduct = {} as IOutboundDeliveryNoteProduct;
                    product.goodName = p.goodName;
                    product.inboundCode = p.codeInbound;
                    product.totalCases = p.totalCases;
                    product.totalWeight = p.weight ? p.weight * (p.totalCases / (p.totalCases || 1)) : 0; // ✅ peso estimado
                    if (this.OutboundDeliveryNotesDetailList.length === 0) {
                        product.inDeliveryNote = 0;
                    } else {
                        product.inDeliveryNote = this.OutboundDeliveryNotesDetailList.filter(o => o.goodName === p.goodName && o.idOutboundDetail === p.id)
                        .reduce((sum, current) => sum + current.totalCases, 0);
                    }
                    product.totalWeight = p.weight ? p.weight * (p.totalCases / (p.totalCases || 1)) : 0;
                    product.idOutboundDetail = p.id;
                    outboundDeliveryNoteProduct.push(product);
                }
            });
        }
        return outboundDeliveryNoteProduct;
    }

    get OutboundDeliveryNotesDetailListFiltered() {
        if (this.OutboundDeliveryNoteProductSelected.length > 0) {
            return this.OutboundDeliveryNotesDetailList.filter(o => o.goodName === this.OutboundDeliveryNoteProductSelected[0].goodName && o.idOutboundDetail === this.OutboundDeliveryNoteProductSelected[0].idOutboundDetail);
        }
        return [];
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.SelectedOutbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    resetOutboundDeliveryNotesDetail() {
        this.selectedOutboundDeliveryNotesDetail = [];
        this.selectedStockCustomerToDelivery = null;
    }

    saveOutboundDeliveryNotesDetail () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.selectedStockCustomerToDelivery === null) {
                this.showMessageWarning('Please select a stock to save');
            } else {
                let sumProductSelected : number = this.selectedStockCustomerToDelivery.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
                if (sumProductSelected > this.OutboundDeliveryNoteProductSelected[0].totalCases) {
                    this.showMessageWarning('The total of selected products is greater than the quantity needed for this product.');
                } else {
                    this.selectedStockCustomerToDelivery.forEach(p => {
                        p.idOutboundDetail = this.OutboundDeliveryNoteProductSelected[0].idOutboundDetail;
                    });
                    if (this.SelectedOutbound.statusName !== 'Completed' || this.CanModifyCompletedOutbounds) {
                        this.$emit('saveOutboundDeliveryNotesDetail', this.selectedStockCustomerToDelivery);
                    }
                    this.close();
                }
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    deleteOutboundDeliveryNotesDetail (outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) {
        if (this.selectedOutboundDeliveryNotesDetail.length > 0) {
            this.$emit('deleteOutboundDeliveryNotesDetail', outboundDeliveryNotesDetail);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    select(item : IOutboundDeliveryNotesDetail) : void {
        let index : number = this.selectedOutboundDeliveryNotesDetail.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedOutboundDeliveryNotesDetail = [item];
        } else {
            let outboundDeliveryNotesDetail = this.selectedOutboundDeliveryNotesDetail.find(w => w.id === item.id);
            if (!outboundDeliveryNotesDetail) {
                this.selectedOutboundDeliveryNotesDetail = [];
            }
        }
    }

    getCustomerStockFiltered() {
        this.selectedStockCustomerToDelivery = null;
        this.$emit('getCustomerStockFiltered');
    }
}
